export const getScopeAttributes = (scopeId, scopeType, session) => {
  if(scopeType === 'Employment') {
    const employment = session.employment.withId(scopeId)
    return {scopeName: employment?.name, scopeColor: employment?.color}
  }
  const team = session.team.withId(scopeId)
  return {scopeName: team?.name, scopeColor: "#939393"}
}
